import { useState } from 'react';
import { useDebugStore } from '../store/debugStore';
import { useSceneStore } from '../store/sceneStore';

export function DebugMenu() {
    const [visible, setVisible] = useState(false);
    const { fps, drawCalls, triangles } = useDebugStore();
    const { setFov, setShowAxes, setAutoRotate, triggerResetCamera } = useSceneStore();
    const autoRotate = useSceneStore((state) => state.autoRotate);

    const handleFullscreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
    };

    return (
        <>
            <button id="debug-toggle" onClick={() => setVisible((v) => !v)}>⚙</button>
            {visible && (
                <div id="debug-menu">
                    <h3>Debug Menu</h3>
                    <section className="debug-section">
                        <div className="debug-row">
                            <span className="debug-label">FPS:</span>
                            <span className="debug-value" id="fps-counter">{fps}</span>
                        </div>
                        <div className="debug-row">
                            <span className="debug-label">Triangles:</span>
                            <span className="debug-value" id="triangle-count">{triangles}</span>
                        </div>
                        <div className="debug-row">
                            <span className="debug-label">Draw Calls:</span>
                            <span className="debug-value" id="draw-calls">{drawCalls}</span>
                        </div>
                    </section>
                    <section className="debug-section">
                        <div className="debug-control">
                            <label>FOV</label>
                            <input
                                type="range"
                                id="fov"
                                min="30"
                                max="100"
                                step="1"
                                defaultValue="75"
                                onChange={(e) => setFov(parseFloat(e.target.value))}
                            />
                        </div>
                        <div className="debug-control">
                            <label>
                                <input
                                    type="checkbox"
                                    id="show-axes"
                                    onChange={(e) => setShowAxes(e.target.checked)}
                                />{' '}
                                Show Axes
                            </label>
                        </div>
                        <div className="debug-control">
                            <label>
                                <input type="checkbox" id="wireframe" defaultChecked /> Wireframe
                            </label>
                        </div>
                        <div className="debug-control">
                            <label>
                                <input
                                    type="checkbox"
                                    id="auto-rotate"
                                    checked={autoRotate}
                                    onChange={(e) => setAutoRotate(e.target.checked)}
                                />{' '}
                                Auto Rotate
                            </label>
                        </div>
                    </section>
                    <section className="debug-section">
                        <button className="debug-button" id="reset-camera" onClick={triggerResetCamera}>
                            Reset Camera
                        </button>
                        <button className="debug-button" id="fullscreen" onClick={handleFullscreen}>
                            Fullscreen
                        </button>
                    </section>
                </div>
            )}
        </>
    );
}
